var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{staticClass:"d-flex flex-column justify-center align-center",attrs:{"fill-height":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent lighten-2","size":50,"width":5,"aria-label":"Loading Page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }